import { Modal } from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'

const FlightNotFetch = ({ messageData, setIsModalOpenFlightNotFetch, isModalOpenFlightNotFetch }) => {
    const navigate = useNavigate();

    const handleNavigation = () => {
        navigate(-1);
    };

    return (
        <div>
            <Modal
                className='close_button p-0'
                open={isModalOpenFlightNotFetch}
                footer={null}
                onCancel={() => setIsModalOpenFlightNotFetch(false)}
                centered
                destroyOnClose={true}
                width={320}
            >
                <>
                    <div className='text-center'>
                        <h4 className='mb-1'>Uh Oh!</h4>
                        <p className='mb-3'>Sorry, {messageData}</p>
                        <button onClick={handleNavigation} className='btn btn-primary py-2 d-block w-100 border-0'  aria-label="ok got it">Ok got it</button>
                    </div>
                </>
            </Modal>
        </div>
    )
}

export default FlightNotFetch
